import { forwardRef } from 'react';

import { Button, Center, Heading, Text, VStack, theme } from '@squire/ui';

import { MapPinFilledIcon } from '@/components/_icons/MapPinFilledIcon';
import type { BottomSheetRef } from '@/components/_shared/BottomSheet';
import { BottomSheet } from '@/components/_shared/BottomSheet';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { LocationBottomSheetProps } from './types';

const HomeLocationBottomSheet = forwardRef<
  BottomSheetRef,
  LocationBottomSheetProps
>(({ isDismissible = true, onContinue, ...props }, ref) => {
  const { t } = useScreenTranslations('HomeScreen');

  return (
    <BottomSheet
      {...props}
      dismissible={isDismissible}
      ref={ref}
      style={styles.bottomSheet}
    >
      <VStack
        flex
        space={theme.spacing[8]}
        paddingHorizontal={theme.spacing[6]}
        style={styles.content}
      >
        <Heading variant="s">{t('location')}</Heading>
        <Center flex>
          <Center style={styles.locationIcon}>
            <MapPinFilledIcon size={24} fill="borderSubtle" />
          </Center>
        </Center>
        <Text variant="l" align="center">
          {t('locationDescription')}
        </Text>
        <Button testID="continue-button" onPress={onContinue}>
          {t('continue')}
        </Button>
      </VStack>
    </BottomSheet>
  );
});

HomeLocationBottomSheet.displayName = 'LocationBottomSheet';
export { HomeLocationBottomSheet };
